export enum ChipTheme {
  Active = 'active',
  Emphasis = 'emphasis',
  Light = 'light',
}
